module.exports = __webpack_public_path__ + "static/media/2.137c29c9.png";